import { Injectable } from '@angular/core';
import { UserRole } from '@carm/_core/access-control-mgt/models/user-role.model';
import { ICompanyProgram, IProgramItem } from '../models/menu-program.model';
@Injectable()
export class MenuService {
  showMenu = false;

  constructor() {}

  buildProgramMenu(userRole: UserRole, bn9: string, bn15: string): ICompanyProgram {

    return this.mapRoleToProgramMenu(userRole, bn9, bn15)
  }

  mapRoleToProgramMenu(userRole: UserRole, bn9: string, bn15: string): ICompanyProgram {
    if (
      userRole === undefined ||
      userRole.roles === undefined ||
      userRole.roles.length === 0
    ) {
      return null;
    }

    let currentProgram = userRole.roles.find(p => p.program.uid === bn15)?.program;

    if(currentProgram){
      let companyProgram: ICompanyProgram = {
        companyUid: currentProgram.companyUid,
        companyName: currentProgram.companyName,
        programName: currentProgram.name,
        programUid: currentProgram.uid,
        programs: userRole.roles.filter(p => p.program.companyUid === bn9).sortRoleByProgramRM().map(r => r.program).map(p => {
          let program: IProgramItem = {
            programUid: p.uid,
            programName: p.name,
            rmNumber: p.uid.substring(9)
          }

          return program;
        })
      };

      return companyProgram;
    }else{
      return null;
    }
  }
}
